<div class="page-layout carded fullwidth">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT HEADER -->
        <div
            class="header accent p-24"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <div>
                <h2 class="m-0">
                    <span class="px-20">{{ cliente?.nombre }}</span>
                </h2>
            </div>
            <div
                class="toolbar px-24 py-8"
                fxLayoutAlign="end center"
                fxFlex
                fxLayout="row"
            >
                <div fxFlex fxLayout="row" fxLayoutAlign="end center">
                    <button
                        mat-button
                        (click)="enviarComentario()"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon aria-hidden="false" aria-label="print"
                            >comment</mat-icon
                        >
                    </button>
                </div>
                <button
                    mat-button
                    (click)="guardaeCambios()"
                    mat-flat-button
                    color="primary"
                    class="add-row"
                >
                    <mat-icon aria-hidden="false" aria-label="Guardar cambios"
                        >save</mat-icon
                    >
                    Guardar cambios
                </button>
            </div>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <mat-tab-group dynamicHeight>
                <mat-tab label="Información">
                    <div
                        class="widget-group p-12"
                        fxLayout="column wrap"
                        fxFlex="100"
                        *fuseIfOnDom
                    >
                        <!-- Datos del cliente-->
                        <div *ngIf="viewSectorActividad">
                            <mat-label fxFlex="50"
                                >Sector de actividad</mat-label
                            >
                            <mat-label fxFlex="50">{{
                                GENERAL_DATA.sectorIndustrial.nombre
                            }}</mat-label>
                        </div>

                        <div fxLayout="row">
                            <mat-form-field
                                *ngIf="!viewSectorActividad"
                                class="select-list"
                            >
                                <mat-label>Sector de actividad</mat-label>
                                <mat-select
                                    [(ngModel)]="GENERAL_DATA.sectorIndustrial"
                                    class="roleSelect"
                                    [disabled]="action == 'View'"
                                    [compareWith]="compareObjects"
                                >
                                    <mat-option
                                        *ngFor="
                                            let tipo of tiposSectorIndustrial
                                        "
                                        [value]="tipo"
                                    >
                                        {{ tipo.nombre }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div
                            fxLayout="column"
                            id="personaFisica"
                            *ngIf="
                                cliente?.tipo == 'PERSONA_FISICA' &&
                                action != 'Delete'
                            "
                        >
                            <div *ngIf="viewSProfesion">
                                <mat-label fxFlex="50">Profesión</mat-label>
                                <mat-label fxFlex="50">{{
                                    cliente.personaFisica.profesion.nombre
                                }}</mat-label>
                            </div>

                            <div fxLayout="column" *ngIf="!viewSProfesion">
                                <mat-form-field class="select-list">
                                    <mat-label>Profesión</mat-label>
                                    <mat-select
                                        [(ngModel)]="
                                            cliente.personaFisica.profesion
                                        "
                                        class="roleSelect"
                                        [disabled]="action == 'View'"
                                        [compareWith]="compareObjects"
                                    >
                                        <mat-option
                                            *ngFor="
                                                let profesion of tiposProfesiones
                                            "
                                            [value]="profesion"
                                        >
                                            {{ profesion.nombre }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxLayout="column">
                                <mat-checkbox
                                    class="example-margin"
                                    [(ngModel)]="
                                        cliente.personaFisica
                                            .personaPoliticamenteExpuesta
                                    "
                                    [disabled]="viewPEP"
                                    (change)="saveValue(sentencia, element)"
                                    >Persona politícamente
                                    expuesta</mat-checkbox
                                >
                            </div>

                            <div *ngIf="viewNombre">
                                <mat-label fxFlex="50">Nombre</mat-label>
                                <mat-label fxFlex="50">{{
                                    cliente.personaFisica.nombre
                                }}</mat-label>
                            </div>

                            <div fxLayout="row">
                                <div *ngIf="!viewNombre">
                                    <mat-form-field
                                        class="select-medio"
                                        fxFlex="100"
                                    >
                                        <input
                                            placeholder="Nombre"
                                            matInput
                                            [(ngModel)]="
                                                cliente.personaFisica.nombre
                                            "
                                        />
                                    </mat-form-field>
                                </div>

                                <div *ngIf="!viewSegundoNombre">
                                    <mat-form-field
                                        class="select-medio"
                                        fxFlex="100"
                                    >
                                        <input
                                            placeholder="Segundo nombre"
                                            matInput
                                            [(ngModel)]="
                                                cliente.personaFisica
                                                    .segundoNombre
                                            "
                                        />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div *ngIf="viewSegundoNombre">
                                <mat-label fxFlex="50"
                                    >Segundo Nombre</mat-label
                                >
                                <mat-label fxFlex="50">{{
                                    cliente.personaFisica.segundoNombre
                                }}</mat-label>
                            </div>

                            <div *ngIf="viewApellido">
                                <mat-label fxFlex="50">Apellido</mat-label>
                                <mat-label fxFlex="50">{{
                                    cliente.personaFisica.apellido
                                }}</mat-label>
                            </div>

                            <div fxLayout="row">
                                <div *ngIf="!viewApellido">
                                    <mat-form-field
                                        class="select-medio"
                                        fxFlex="100"
                                    >
                                        <input
                                            placeholder="Apellido"
                                            matInput
                                            [(ngModel)]="
                                                cliente.personaFisica.apellido
                                            "
                                        />
                                    </mat-form-field>
                                </div>
                                <div *ngIf="!viewSegundoApellido">
                                    <mat-form-field
                                        class="select-medio"
                                        fxFlex="100"
                                    >
                                        <input
                                            placeholder="Segundo apellido"
                                            matInput
                                            [(ngModel)]="
                                                cliente.personaFisica
                                                    .segundoApellido
                                            "
                                        />
                                    </mat-form-field>
                                </div>
                            </div>

                            <div *ngIf="viewSegundoApellido">
                                <mat-label fxFlex="50"
                                    >Segundo Apellido</mat-label
                                >
                                <mat-label fxFlex="50">{{
                                    cliente.personaFisica.segundoApellido
                                }}</mat-label>
                            </div>

                            <div *ngIf="viewPais">
                                <mat-label fxFlex="50"
                                    >País de nacimiento</mat-label
                                >
                                <mat-label fxFlex="50">{{
                                    cliente.personaFisica.lugarNacimiento.nombre
                                }}</mat-label>
                            </div>
                            <div fxLayout="row">
                                <mat-form-field
                                    *ngIf="!viewPais"
                                    class="select-list"
                                    fxFlex="50"
                                >
                                    <mat-label>País de nacimiento</mat-label>
                                    <mat-select
                                        [(ngModel)]="
                                            cliente.personaFisica
                                                .lugarNacimiento
                                        "
                                        class="roleSelect"
                                        [disabled]="action == 'View'"
                                        [compareWith]="compareObjects"
                                    >
                                        <mat-option
                                            *ngFor="let pais of paises"
                                            [value]="pais"
                                        >
                                            {{ pais.nombre }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-form-field
                                    color="accent"
                                    appearance="fill"
                                    fxFlex="50"
                                >
                                    <mat-label>Fecha de nacimiento</mat-label>
                                    <input
                                        matInput
                                        [matDatepicker]="picker3"
                                        [(ngModel)]="
                                            cliente.personaFisica
                                                .fechaNacimiento
                                        "
                                    />
                                    <mat-datepicker-toggle
                                        matSuffix
                                        [for]="picker3"
                                    ></mat-datepicker-toggle>
                                    <mat-datepicker #picker3></mat-datepicker>
                                </mat-form-field>
                            </div>

                            <div *ngIf="viewFechaDeNacimiento">
                                <mat-label fxFlex="50"
                                    >Fecha de nacimiento</mat-label
                                >
                                <mat-label fxFlex="50">{{
                                    cliente.personaFisica.fechaNacimiento
                                        | date : "dd/MM/yyyy"
                                }}</mat-label>
                            </div>

                            <fieldset>
                                <legend>Datos de contacto</legend>

                                <div *ngIf="viewCorreoElectronico">
                                    <mat-label fxFlex="50"
                                        >Correo electrónico</mat-label
                                    >
                                    <mat-label fxFlex="50">{{
                                        cliente.personaFisica.contacto
                                            .correoElectronico
                                    }}</mat-label>
                                </div>

                                <div *ngIf="viewTelefono">
                                    <mat-label fxFlex="50">Teléfono</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.telefono.numero
                                    }}</mat-label>
                                </div>

                                <div
                                    fxLayout="column"
                                    *ngIf="!viewCorreoElectronico"
                                >
                                    <mat-form-field
                                        class="select-full"
                                        fxFlex="100"
                                    >
                                        <input
                                            placeholder="Correo electrónico"
                                            matInput
                                            [(ngModel)]="
                                                GENERAL_DATA.correoElectronico
                                                    .correo
                                            "
                                        />
                                    </mat-form-field>

                                    <div fxLayout="row" *ngIf="!viewTelefono">
                                        <mat-form-field
                                            class="select-full"
                                            fxFlex="100"
                                        >
                                            <input
                                                placeholder="Teléfono"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.telefono.numero
                                                "
                                            />
                                        </mat-form-field>
                                        <mat-form-field
                                            class="select-full"
                                            fxFlex="100"
                                        >
                                            <input
                                                placeholder="Interno"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.telefono
                                                        .interno
                                                "
                                            />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset>
                                <legend>Documento de identificación</legend>
                                <div fxLayout="column">
                                    <div *ngIf="viewDocumento">
                                        <mat-label fxFlex="50"
                                            >Tipo de documento</mat-label
                                        >
                                        <mat-label fxFlex="50">{{
                                            GENERAL_DATA.razonSocial?.tipo
                                                ?.nombre
                                        }}</mat-label>
                                    </div>
                                    <div *ngIf="viewDocumento">
                                        <mat-label fxFlex="50"
                                            >Numero de documento</mat-label
                                        >
                                        <mat-label fxFlex="50">{{
                                            GENERAL_DATA.razonSocial?.numero
                                        }}</mat-label>
                                    </div>

                                    <div *ngIf="viewDocumento">
                                        <mat-label
                                            fxFlex="50"
                                            *ngIf="viewDocumentoFechaExpiracion"
                                            >Fecha de emisión</mat-label
                                        >
                                        <mat-label
                                            fxFlex="50"
                                            *ngIf="viewDocumentoFechaExpiracion"
                                            >{{
                                                GENERAL_DATA.razonSocial
                                                    ?.fechaExpedicion
                                            }}</mat-label
                                        >
                                    </div>
                                    <div *ngIf="viewDocumento">
                                        <mat-label
                                            fxFlex="50"
                                            *ngIf="
                                                viewDocumentoFechaVencimiento
                                            "
                                            >Fecha de expiración</mat-label
                                        >
                                        <mat-label
                                            fxFlex="50"
                                            *ngIf="
                                                viewDocumentoFechaVencimiento
                                            "
                                            >{{
                                                GENERAL_DATA.razonSocial
                                                    ?.fechaVencimiento
                                            }}</mat-label
                                        >
                                    </div>

                                    <div fxLayout="row" *ngIf="!viewDocumento">
                                        <mat-form-field
                                            class="select-list"
                                            fxFlex="100"
                                        >
                                            <mat-label
                                                >Tipo de documento</mat-label
                                            >
                                            <mat-select
                                                [(ngModel)]="
                                                    GENERAL_DATA.razonSocial
                                                        .tipo
                                                "
                                                class="roleSelect"
                                                [disabled]="action == 'View'"
                                                [compareWith]="compareObjects"
                                            >
                                                <ng-container
                                                    *ngFor="
                                                        let tipo of tiposDocumentos
                                                    "
                                                >
                                                    <mat-option [value]="tipo">
                                                        {{ tipo.nombre }}
                                                    </mat-option>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Número de documento"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.razonSocial
                                                        .numero
                                                "
                                            />
                                        </mat-form-field>
                                    </div>
                                    <div fxLayout="row">
                                        <div
                                            fxFlex="100"
                                            *ngIf="
                                                !viewDocumentoFechaExpiracion
                                            "
                                        >
                                            <mat-form-field
                                                color="accent"
                                                appearance="fill"
                                            >
                                                <mat-label
                                                    >Fecha de emisión</mat-label
                                                >
                                                <input
                                                    matInput
                                                    [matDatepicker]="picker1"
                                                    [(ngModel)]="
                                                        GENERAL_DATA.razonSocial
                                                            .fechaExpedicion
                                                    "
                                                />
                                                <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="picker1"
                                                ></mat-datepicker-toggle>
                                                <mat-datepicker
                                                    #picker1
                                                ></mat-datepicker>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            fxFlex="100"
                                            *ngIf="
                                                !viewDocumentoFechaVencimiento
                                            "
                                        >
                                            <mat-form-field
                                                color="accent"
                                                appearance="fill"
                                            >
                                                <mat-label
                                                    >Fecha de
                                                    expiración</mat-label
                                                >
                                                <input
                                                    matInput
                                                    [matDatepicker]="picker2"
                                                    [(ngModel)]="
                                                        GENERAL_DATA.razonSocial
                                                            .fechaVencimiento
                                                    "
                                                />
                                                <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="picker2"
                                                ></mat-datepicker-toggle>
                                                <mat-datepicker
                                                    #picker2
                                                ></mat-datepicker>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset>
                                <legend>Domicilio</legend>

                                <div *ngIf="viewDireccion">
                                    <mat-label fxFlex="50">País</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFisica.pais.nombre
                                    }}</mat-label>
                                </div>
                                <div *ngIf="viewDireccion">
                                    <mat-label fxFlex="50">Localidad</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFisica.localidad
                                    }}</mat-label>
                                </div>

                                <div *ngIf="viewDireccion">
                                    <mat-label fxFlex="50">Calle</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFisica.calle
                                    }}</mat-label>
                                </div>
                                <div *ngIf="viewDireccion">
                                    <mat-label fxFlex="50"
                                        >Numero de puerta</mat-label
                                    >
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFisica
                                            .numeroDePuerta
                                    }}</mat-label>
                                </div>

                                <div *ngIf="viewDireccion">
                                    <mat-label fxFlex="50">Unidad</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFisica
                                            .numeroDeApartamento
                                    }}</mat-label>
                                </div>

                                <div fxLayout="column" *ngIf="!viewDireccion">
                                    <div fxLayout="row">
                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Calle"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFisica
                                                        .calle
                                                "
                                            />
                                        </mat-form-field>

                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Número de puerta"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFisica
                                                        .numeroDePuerta
                                                "
                                            />
                                        </mat-form-field>

                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Unidad"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFisica
                                                        .numeroDeApartamento
                                                "
                                            />
                                        </mat-form-field>
                                    </div>
                                    <div fxLayout="row">
                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Localidad"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFisica
                                                        .localidad
                                                "
                                            />
                                        </mat-form-field>

                                        <mat-form-field
                                            class="select-list"
                                            fxFlex="100"
                                        >
                                            <mat-label>País</mat-label>
                                            <mat-select
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFisica
                                                        .pais
                                                "
                                                class="roleSelect"
                                                [disabled]="action == 'View'"
                                                [compareWith]="compareObjects"
                                            >
                                                <mat-option
                                                    *ngFor="let pais of paises"
                                                    [value]="pais"
                                                >
                                                    {{ pais.nombre }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <div
                            fxLayout="column"
                            id="personaJuridica"
                            *ngIf="
                                cliente?.tipo == 'PERSONA_JURIDICA' &&
                                action != 'Delete'
                            "
                        >
                            <div fxLayout="row" *ngIf="!viewNombre">
                                <mat-form-field
                                    class="select-medio"
                                    fxFlex="100"
                                >
                                    <input
                                        placeholder="Nombre"
                                        matInput
                                        [(ngModel)]="
                                            cliente.personaJuridica.nombre
                                        "
                                    />
                                </mat-form-field>
                            </div>

                            <div *ngIf="viewNombre">
                                <mat-label fxFlex="50">Nombre</mat-label>
                                <mat-label fxFlex="50">{{
                                    cliente.personaJuridica.nombre
                                }}</mat-label>
                            </div>

                            <fieldset>
                                <legend>Datos de contacto</legend>

                                <div *ngIf="viewCorreoElectronico">
                                    <mat-label fxFlex="50"
                                        >Correo electrónico</mat-label
                                    >
                                    <mat-label fxFlex="50">{{
                                        cliente.personaJuridica.contacto
                                            .correoElectronico
                                    }}</mat-label>
                                </div>

                                <div *ngIf="viewTelefono">
                                    <mat-label fxFlex="50">Teléfono</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.telefono.numero
                                    }}</mat-label>
                                </div>

                                <div
                                    fxLayout="column"
                                    *ngIf="!viewCorreoElectronico"
                                >
                                    <mat-form-field
                                        class="select-full"
                                        fxFlex="100"
                                    >
                                        <input
                                            placeholder="Correo electrónico"
                                            matInput
                                            [(ngModel)]="
                                                GENERAL_DATA.correoElectronico
                                                    .correo
                                            "
                                        />
                                    </mat-form-field>

                                    <div fxLayout="row" *ngIf="!viewTelefono">
                                        <mat-form-field
                                            class="select-full"
                                            fxFlex="100"
                                        >
                                            <input
                                                placeholder="Teléfono"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.telefono.numero
                                                "
                                            />
                                        </mat-form-field>
                                        <mat-form-field
                                            class="select-full"
                                            fxFlex="100"
                                        >
                                            <input
                                                placeholder="Interno"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.telefono
                                                        .interno
                                                "
                                            />
                                        </mat-form-field>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset>
                                <legend>Documento de identificación</legend>
                                <div fxLayout="column">
                                    <div *ngIf="viewDocumento">
                                        <mat-label fxFlex="50"
                                            >Tipo de documento</mat-label
                                        >
                                        <mat-label fxFlex="50">{{
                                            GENERAL_DATA.razonSocial?.tipo
                                                ?.nombre
                                        }}</mat-label>
                                    </div>
                                    <div *ngIf="viewDocumento">
                                        <mat-label fxFlex="50"
                                            >Numero de documento</mat-label
                                        >
                                        <mat-label fxFlex="50">{{
                                            GENERAL_DATA.razonSocial?.numero
                                        }}</mat-label>
                                    </div>

                                    <div *ngIf="viewDocumento">
                                        <mat-label
                                            fxFlex="50"
                                            *ngIf="viewDocumentoFechaExpedicion"
                                            >Fecha de emisión</mat-label
                                        >
                                        <mat-label
                                            fxFlex="50"
                                            *ngIf="viewDocumentoFechaExpedicion"
                                            >{{
                                                GENERAL_DATA.razonSocial
                                                    ?.fechaExpedicion
                                                    | date : "dd/MM/yyyy"
                                            }}</mat-label
                                        >
                                    </div>
                                    <div *ngIf="viewDocumento">
                                        <mat-label
                                            fxFlex="50"
                                            *ngIf="
                                                viewDocumentoFechaVencimiento
                                            "
                                            >Fecha de expiración</mat-label
                                        >
                                        <mat-label
                                            fxFlex="50"
                                            *ngIf="
                                                viewDocumentoFechaVencimiento
                                            "
                                            >{{
                                                GENERAL_DATA.razonSocial
                                                    ?.fechaVencimiento
                                                    | date : "dd/MM/yyyy"
                                            }}</mat-label
                                        >
                                    </div>

                                    <div fxLayout="row" *ngIf="!viewDocumento">
                                        <mat-form-field
                                            class="select-list"
                                            fxFlex="100"
                                        >
                                            <mat-label
                                                >Tipo de documento</mat-label
                                            >
                                            <mat-select
                                                [(ngModel)]="
                                                    GENERAL_DATA.razonSocial
                                                        .tipo
                                                "
                                                class="roleSelect"
                                                [disabled]="action == 'View'"
                                                [compareWith]="compareObjects"
                                            >
                                                <ng-container
                                                    *ngFor="
                                                        let tipo of tiposDocumentos
                                                    "
                                                >
                                                    <mat-option [value]="tipo">
                                                        {{ tipo.nombre }}
                                                    </mat-option>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Número de documento"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.razonSocial
                                                        .numero
                                                "
                                            />
                                        </mat-form-field>
                                    </div>
                                    <div fxLayout="row">
                                        <div
                                            fxFlex="100"
                                            *ngIf="
                                                !viewDocumentoFechaExpedicion
                                            "
                                        >
                                            <mat-form-field
                                                color="accent"
                                                appearance="fill"
                                            >
                                                <mat-label
                                                    >Fecha de emisión</mat-label
                                                >
                                                <input
                                                    matInput
                                                    [matDatepicker]="picker1"
                                                    [(ngModel)]="
                                                        GENERAL_DATA.razonSocial
                                                            .fechaExpedicion
                                                    "
                                                />
                                                <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="picker1"
                                                ></mat-datepicker-toggle>
                                                <mat-datepicker
                                                    #picker1
                                                ></mat-datepicker>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            fxFlex="100"
                                            *ngIf="
                                                !viewDocumentoFechaVencimiento
                                            "
                                        >
                                            <mat-form-field
                                                color="accent"
                                                appearance="fill"
                                            >
                                                <mat-label
                                                    >Fecha de
                                                    expiración</mat-label
                                                >
                                                <input
                                                    matInput
                                                    [matDatepicker]="picker2"
                                                    [(ngModel)]="
                                                        GENERAL_DATA.razonSocial
                                                            .fechaVencimiento
                                                    "
                                                />
                                                <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="picker2"
                                                ></mat-datepicker-toggle>
                                                <mat-datepicker
                                                    #picker2
                                                ></mat-datepicker>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset>
                                <legend>Dirección fisica</legend>

                                <div *ngIf="viewDireccion">
                                    <mat-label fxFlex="50">País</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFisica.pais.nombre
                                    }}</mat-label>
                                </div>
                                <div *ngIf="viewDireccion">
                                    <mat-label fxFlex="50">Localidad</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFisica.localidad
                                    }}</mat-label>
                                </div>

                                <div *ngIf="viewDireccion">
                                    <mat-label fxFlex="50">Calle</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFisica.calle
                                    }}</mat-label>
                                </div>
                                <div *ngIf="viewDireccion">
                                    <mat-label fxFlex="50"
                                        >Numero de puerta</mat-label
                                    >
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFisica
                                            .numeroDePuerta
                                    }}</mat-label>
                                </div>

                                <div *ngIf="viewDireccion">
                                    <mat-label fxFlex="50">Unidad</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFisica
                                            .numeroDeApartamento
                                    }}</mat-label>
                                </div>

                                <div fxLayout="column" *ngIf="!viewDireccion">
                                    <div fxLayout="row">
                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Calle"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFisica
                                                        .calle
                                                "
                                            />
                                        </mat-form-field>

                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Número de puerta"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFisica
                                                        .numeroDePuerta
                                                "
                                            />
                                        </mat-form-field>

                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Unidad"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFisica
                                                        .numeroDeApartamento
                                                "
                                            />
                                        </mat-form-field>
                                    </div>
                                    <div fxLayout="row">
                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Localidad"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFisica
                                                        .localidad
                                                "
                                            />
                                        </mat-form-field>

                                        <mat-form-field
                                            class="select-list"
                                            fxFlex="100"
                                        >
                                            <mat-label>País</mat-label>
                                            <mat-select
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFisica
                                                        .pais
                                                "
                                                class="roleSelect"
                                                [disabled]="action == 'View'"
                                                [compareWith]="compareObjects"
                                            >
                                                <mat-option
                                                    *ngFor="let pais of paises"
                                                    [value]="pais"
                                                >
                                                    {{ pais.nombre }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </fieldset>

                            <fieldset>
                                <legend>Dirección fiscal</legend>

                                <div *ngIf="viewDireccionFiscal">
                                    <mat-label fxFlex="50">País</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFiscal.pais.nombre
                                    }}</mat-label>
                                </div>
                                <div *ngIf="viewDireccionFiscal">
                                    <mat-label fxFlex="50">Localidad</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFiscal.localidad
                                    }}</mat-label>
                                </div>

                                <div *ngIf="viewDireccionFiscal">
                                    <mat-label fxFlex="50">Calle</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFiscal.calle
                                    }}</mat-label>
                                </div>
                                <div *ngIf="viewDireccionFiscal">
                                    <mat-label fxFlex="50"
                                        >Numero de puerta</mat-label
                                    >
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFiscal
                                            .numeroDePuerta
                                    }}</mat-label>
                                </div>

                                <div *ngIf="viewDireccionFiscal">
                                    <mat-label fxFlex="50">Unidad</mat-label>
                                    <mat-label fxFlex="50">{{
                                        GENERAL_DATA.direccionFiscal
                                            .numeroDeApartamento
                                    }}</mat-label>
                                </div>

                                <div
                                    fxLayout="column"
                                    *ngIf="!viewDireccionFiscal"
                                >
                                    <div fxLayout="row">
                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Calle"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFiscal
                                                        .calle
                                                "
                                            />
                                        </mat-form-field>

                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Número de puerta"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFiscal
                                                        .numeroDePuerta
                                                "
                                            />
                                        </mat-form-field>

                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Unidad"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFiscal
                                                        .numeroDeApartamento
                                                "
                                            />
                                        </mat-form-field>
                                    </div>
                                    <div fxLayout="row">
                                        <mat-form-field fxFlex="100">
                                            <input
                                                placeholder="Localidad"
                                                matInput
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFiscal
                                                        .localidad
                                                "
                                            />
                                        </mat-form-field>

                                        <mat-form-field
                                            class="select-list"
                                            fxFlex="100"
                                        >
                                            <mat-label>País</mat-label>
                                            <mat-select
                                                [(ngModel)]="
                                                    GENERAL_DATA.direccionFiscal
                                                        .pais
                                                "
                                                class="roleSelect"
                                                [disabled]="action == 'View'"
                                                [compareWith]="compareObjects"
                                            >
                                                <mat-option
                                                    *ngFor="let pais of paises"
                                                    [value]="pais"
                                                >
                                                    {{ pais.nombre }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </fieldset>
                        </div>

                        <!-- Fin datos del clietne -->
                    </div>
                    <!-- / WIDGET GROUP -->
                </mat-tab>

                <mat-tab
                    label="Accionistas"
                    *ngIf="cliente?.tipo == 'PERSONA_JURIDICA'"
                >
                    <!-- WIDGET GROUP -->
                    <div
                        class="widget-group"
                        fxLayout="column wrap"
                        fxFlex="100"
                        *fuseIfOnDom
                    >
                        <div class="content p-24">
                            <table
                                mat-table
                                [dataSource]="accionistas"
                                #mytable
                                class="my-table mat-elevation-z8"
                            >
                                <!--- Note that these columns can be defined in any order.
                                       The actual rendered columns are set as a property on the row definition" -->

                                <!-- User Column -->
                                <ng-container matColumnDef="nombre">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Nombre
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.nombreCompleto }}
                                    </td>
                                </ng-container>

                                <!-- Role Column -->
                                <ng-container matColumnDef="correoElectronico">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Documento
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{
                                            element.documentoIdentidad?.tipo
                                                .nombre
                                        }}
                                        |
                                        {{ element.documentoIdentidad?.numero }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Acción
                                    </th>
                                    <td
                                        mat-cell
                                        *matCellDef="let element"
                                        class="action-link"
                                    >
                                        <a
                                            (click)="
                                                openDialogAccionista(
                                                    'View',
                                                    element
                                                )
                                            "
                                            >Ver</a
                                        >
                                    </td>
                                </ng-container>

                                <tr
                                    mat-header-row
                                    *matHeaderRowDef="
                                        displayedColumnsAccionistas
                                    "
                                ></tr>
                                <tr
                                    mat-row
                                    *matRowDef="
                                        let row;
                                        columns: displayedColumnsAccionistas
                                    "
                                ></tr>
                            </table>
                        </div>
                    </div>
                    <!-- / WIDGET GROUP -->
                </mat-tab>
            </mat-tab-group>
        </div>
        <!-- TABS fin -->
    </div>
</div>
<!-- / CENTER -->
